import React from 'react'
import "./PersonalDetails.css";
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import InfoIcon from '@mui/icons-material/Info';
import ContactsIcon from '@mui/icons-material/Contacts';
import {useState} from 'react';
import Contact from "../Personal Details/Contact";
import Details from "../Personal Details/Details/Details"
import Hobbies from "../Personal Details/Hobbies/Hobbies"

function PersonalDetails() {
  const [showContact , setShowContact] = useState(true);
  const [showDetails , setShowDetails] = useState(false);
  const [showHobbies , setShowHobbies] = useState(false);

  const onClickSC = () =>{
    setShowDetails(false);
    setShowContact(true);
    setShowHobbies(false)
  }

  const onClickSD = () =>{
    setShowDetails(true);
    setShowContact(false);
    setShowHobbies(false)
  }

  const onClickSH = () =>{
    setShowDetails(false);
    setShowContact(false);
    setShowHobbies(true)
  }

  return (
    <div className="personalDetails">
      <div className="heading"><h1> Personal Details</h1></div>

      <div className="Content">
        <ButtonGroup>
        <Button variant="outlined" onClick={onClickSC}> Contact <ContactsIcon/> </Button>
        <Button variant="outlined" onClick={onClickSD}>  Details <InfoIcon/></Button>
        <Button variant="outlined" onClick={onClickSH}>  Hobbies <LocalActivityIcon/> </Button>
        </ButtonGroup>

      <div className="content">
      {showContact? <Contact/>: null}
      {showDetails? <Details/>: null}
      {showHobbies? <Hobbies/>: null}
      </div>
      </div>

    </div>
  )
}

export default PersonalDetails
